import getAllTableViewsContainingItemsForFolder from '../../utils/getAllTableViewsContainingItemsForFolder';
import { removeFromMruTableIdList } from '../helpers/tableCache/updateTablesInCache';
export default function removeFolderInListViewStore(folderId) {
    // delete all the table views for the current folder
    var tableViewsForCurrentFolder = getAllTableViewsContainingItemsForFolder(folderId, false /* shouldIncludeSearchTable */);
    tableViewsForCurrentFolder.forEach(function (tableView) { return removeFromMruTableIdList(tableView.id); });
}
//# sourceMappingURL=removeFolderInListViewStore.js.map